/**
 * StaffResetPasswordReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffResetPasswordReq
 */
export interface StaffResetPasswordReq {
  /** 员工ID */
  id?: string
  /** 新密码 */
  new_password: string
}

/**
 * StaffResetPasswordReq Schema
 */
export const StaffResetPasswordReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '员工ID',
      format: 'string',
      type: 'string',
      label: '员工ID',
    },
    new_password: {
      description: '新密码',
      format: 'string',
      maxLength: 32,
      minLength: 6,
      type: 'string',
      label: '新密码',
    },
  },
  required: ['new_password'],
  type: 'object',
}
